import { render, staticRenderFns } from "./workerCertificateDoctorPra.vue?vue&type=template&id=5d6c5b68&scoped=true&"
import script from "./workerCertificateDoctorPra.vue?vue&type=script&lang=js&"
export * from "./workerCertificateDoctorPra.vue?vue&type=script&lang=js&"
import style0 from "./workerCertificateDoctorPra.vue?vue&type=style&index=0&id=5d6c5b68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6c5b68",
  null
  
)

export default component.exports